import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-header-modal-layout',
  templateUrl: './header-modal-layout.component.html',
  styleUrls: ['./header-modal-layout.component.css']
})
export class HeaderModalLayoutComponent {
  @Output() close = new EventEmitter<void>();

  // Header inputs
  @Input() headerTitle: string = '';
  @Input() headerColor: string = '#000090';

  // Footer inputs
  @Input() footerSubmitText: string = 'Submit';
  @Input() footerCancelText: string = 'Cancel';
  @Input() footerSubmitColor: string = '#000090';
  @Input() footerSubmitDisabled: boolean = false;
  @Output() submit = new EventEmitter<void>();

  // Modal size: 'XL' or 'M'
  @Input() modalSize: 'XL' | 'M' = 'M';

  onClose(): void {
    this.close.emit();
  }

  onSubmit(): void {
    this.submit.emit();
  }
}
